module.exports = __webpack_public_path__ + "img/75776.b3980187.svg";